import { render } from "./KitchenCard.vue?vue&type=template&id=0bdedc44&scoped=true"
import script from "./KitchenCard.vue?vue&type=script&lang=js"
export * from "./KitchenCard.vue?vue&type=script&lang=js"

import "./KitchenCard.vue?vue&type=style&index=0&id=0bdedc44&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdedc44"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QSeparator});
